import { icons } from "~/ui";
import { Providers } from "../types";

type ProviderContentProps = {
  handleProviderSelect: (providerId: number) => void;
  providers: Providers[] | undefined;
};

export const ProviderContent = ({
  handleProviderSelect,
  providers,
}: ProviderContentProps) => {
  return (
    <div className="space-y-2">
      {providers?.map((provider) => (
        <button
          key={provider.id}
          onClick={() => handleProviderSelect(provider.id)}
          className="w-full cursor-pointer rounded-lg bg-gray-50 p-4 text-left transition-all duration-200 hover:bg-gray-100"
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="h-12 w-12 overflow-hidden rounded-full">
                {provider.image ? (
                  <img
                    src={provider.image}
                    alt={provider.name}
                    className="h-full w-full object-cover"
                  />
                ) : (
                  <div className="text-violet flex h-full w-full items-center justify-center bg-violet-100">
                    <span className="text-lg font-semibold">
                      {provider.name.charAt(0)}
                    </span>
                  </div>
                )}
              </div>

              <div className="text-left">
                <h2 className="text-indigo font-sans text-sm font-medium lg:text-base">
                  {provider.name}, {provider.title}
                </h2>
              </div>
            </div>

            <icons.outline.ChevronRightIcon className="text-indigo stroke-3 size-5" />
          </div>
        </button>
      ))}
    </div>
  );
};
